import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { SimpleCodeValue } from '../../../../core/models/code-value.model';
import { ManageComplaintService } from '../../../../core/services/manage-complaints.service';

export interface DeptDialogData {
  jobCardData: any[];
  title: string;
}

@Component({
  selector: 'app-update-complaint-department-dialog',
  standalone: true,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatFormFieldModule, MatSelectModule, MatButtonModule, CommonModule, FormsModule],
  templateUrl: './update-complaint-department-dialog.component.html',
  styleUrl: './update-complaint-department-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateComplaintDepartmentDialogComponent implements OnInit, AfterViewInit {

  readonly dialogRef = inject(MatDialogRef<UpdateComplaintDepartmentDialogComponent>);
  readonly data = inject<DeptDialogData>(MAT_DIALOG_DATA);

  departments: SimpleCodeValue[] = [];
  selectedDepartmentId?: string | number;
  currentDeptId?: string | null;

  constructor(private cdr: ChangeDetectorRef, private manageComplaintService: ManageComplaintService) { }

  ngOnInit(): void {
    const compAssignedDeptId = this.data.jobCardData && this.data.jobCardData[0] ? this.data.jobCardData[0].compAssignedDeptId : null;
    this.currentDeptId = compAssignedDeptId != null ? String(compAssignedDeptId) : null;
    if (compAssignedDeptId) {
      this.manageComplaintService.getDepartmentsWithSameParentDepartment(compAssignedDeptId.toString()).subscribe({
        next: (response) => {
          this.departments = response;
          // If response contains only the current department it will be disabled; ensure selectedDepartmentId isn't set to it
          if (this.selectedDepartmentId && String(this.selectedDepartmentId) === this.currentDeptId) {
            this.selectedDepartmentId = undefined;
          }
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('GET error:', error);
        }
      });
    }
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  onCancel(): void {
    this.dialogRef.close({ approved: false });
  }

  onTransfer(): void {
    this.dialogRef.close({ approved: true, departmentId: this.selectedDepartmentId });
  }

}
